export const whoishylke = `

#### How would you describe yourself?
From a young age, I was always drawn to deep, reflective thinking. My imagination was vivid, and I was a bit of a loner—content to lose myself for hours in wonder, detached from others. That had its pros and cons.

At 18, I was diagnosed with diabetes. Back then, I had just started my pre-training to become a soldier in the Dutch Army. My first blood glucose reading was *22.3 mmol/L*, and just like that, I was ushered into the grinder—the same one every type 1 diabetic has to go through.

Those first few years were tough. Acceptance didn't come easily. I still remember my first hypo—I was convinced I was going to die. For the first decade, I relied on injections and struggled to achieve stable control. I didn't take my sugars seriously at all, and my BG levels were, frankly, a disaster. It wasn't until I was about 26 that I got my first pump. Then, at 30 (now eight years ago), I started researching DIY closed-loop systems.

It took me months to grasp the basics, which is why I tell people I've been looping for eight years now. And honestly? It's the best thing that's ever happened to my life with diabetes.

By profession, I'm an AI engineer, with extensive experience designing, building, and implementing software and cloud solutions—both on the business and technical sides. My driving force in life is to *alleviate or even solve human suffering*, and that's where I derive my sense of purpose.
<br />
<br />

#### Can you tell us something special about you that not so many people know?
At heart, I'm a recluse—more of a farmer than an IT guy. Working with living, growing things feels like breathing for my soul, and I experience it almost as a spiritual practice. This "spiritual" element is the foundation of everything I am.
<br />
<br />

#### What were the biggest challenges you faced with your DIY closed-loop journey?
Early on, I turned too many knobs at once. My initial assumption was: This will solve my health struggles (poor control) without much effort. My technical knowledge will make it easy—just tweak the right settings, and we're done.

But reality demanded something else: *I had to understand my body and behavior much better.* Looping taught me more about how my body works, and that's what ultimately led to better control. Sure, I still have struggles—but it doesn't have to be perfect. Every body and mind is different. Along the way, I've conquered fears and learned patience.

For most of my looping journey, I stuck with the *old algorithm (OpenAPS AMA, circa 2017)* because SMB (Super Micro Bolusing) completely threw me off. Now, years later, I use SMB—but sometimes still revert to AMA for periods.
<br />
<br />

#### Can you tell us about your diabetes journey and what led you to open-source looping?
Most of my story is already covered above. My ex-wife was the one who first pointed out that commercial closed-loop systems existed—but were expensive. I thought: Surely, there's a cheaper, open-source way. And so, my research began. It took a while before I had everything in place to build my own system.
<br />
<br />

#### What are the biggest benefits you've experienced with open-source looping?
In short: *My quality of life has improved dramatically.*
- I sleep better.
- I can push harder in sports.
- I'm less affected by my own shortcomings (forgetfulness, overworking).
<br />
<br />

#### Have you faced any major issues with your open source loop setup? How did you solve them?
There were *plenty*. Yes, I'm technically skilled, but building a loop is a complex beast. Many problems arose, but most were solved by asking fellow loopers on social media—the rest came down to persistence.
<br />
<br />

#### What's your advice for beginners and those struggling with control?
It's a *context-dependent question*—every situation I've seen is different. So, the basics are:
- *Ask experienced loopers for help.*
- *Be patient*—and don't be afraid to experiment.
- *Expect changes* in carb ratios and insulin sensitivity as you loop.
- *Make adjustments one at a time*, not all at once.
- *Educate yourself.* There are no cheat codes in life.
<br />
<br />

#### Where do you see yourself in 10 years?
By then, I hope to have *hacked together an artificial pancreas*—and to have helped many others do the same.
<br />
<br />

<!-- blog-contact-footer -->
`;
